'use client';
import { useQuery } from '@tanstack/react-query';

import { termsApi } from '@/services/api/terms.api';

export const TERMS_QUERY_KEY = ['terms'];

export function useGetStaticPages(id: string | number) {
  return useQuery({
    queryKey: [TERMS_QUERY_KEY, id],
    queryFn: () => termsApi.getStaticPages(id),
    select: (response) => response.data,
    staleTime: 5 * 60 * 1000,
  });
}
